import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types";
import MarketSegmentsDropDown from '../shared/MarketSegmentsDropDown';
import NationalitiesDropDown from '../shared/NationalitiesDropDown';
import Panel from '../shared/Panel';
import { useTextResources } from '../../language';
import { Form} from 'semantic-ui-react';
import moment from 'moment';
import './style.css'
import {DatePicker} from "../shared/DatePicker";

const FolioDetails = ({currentNoRoomFolio, onUpdate}) => {
    const text = useTextResources()
    const [folio, setFolio] = useState({})

    useEffect(() => {
        if(currentNoRoomFolio){
            setFolio(currentNoRoomFolio)
        }
    },[currentNoRoomFolio])

    const updateDates = (openDateValue) => {
        if (moment(folio && folio.EndDate).isSameOrBefore(moment(openDateValue))){
            updateFolio("StartDate", openDateValue)
            updateFolio("EndDate", openDateValue)
        }
        else{
            updateFolio("EndDate", openDateValue)
        }
    }

    const updateFolio = (property, value) => {
        const updatedFolio = {
            ...folio,
            [property]: value
        }
        setFolio(updatedFolio)
        onUpdate(updatedFolio)
    }

    return <div className="FolioDetails">
        <Panel header={text("FolioDetails")} attached={true}>
            <Form>
                <Form.Group widths={2} unstackable>
                    <DatePicker label={text("OpenDate")} required
                    onChange={updateDates} value={moment(folio && folio.StartDate).toDate()} clearable= {false} />
                    <DatePicker label={text("EndDate")} required onChange={(val) => updateFolio("EndDate",val)} 
                    value={moment(folio && folio.EndDate).toDate()} minDate={moment(folio && folio.StartDate).toDate()} clearable= {false} />
                </Form.Group>
                <Form.Field control={MarketSegmentsDropDown} label={text("MarketSegment")} 
                textField="Name" descriptionField="Symbol"  value={folio && folio.MarketSegmentID} 
                onChange={(val) => updateFolio("MarketSegmentID",val)} required/>
                <Form.Field control={NationalitiesDropDown} label={text("Nationality")} 
                textField="Name" descriptionField="Symbol"  value={folio && folio.NationalityID} 
                onChange={(val) => updateFolio("NationalityID",val)}/>
            </Form>
        </Panel>
    </div>
}

FolioDetails.propTypes = {
    OwnerId: PropTypes.number,
    HotelID: PropTypes.number,
    OwnerTypeId: PropTypes.number,
    OnOwner: PropTypes.func,
    currentNoRoomFolio: PropTypes.object,
    onUpdate: PropTypes.func
}
export default FolioDetails